import { internetExplorerBodges } from './dom/internetExplorerBodges';
import { ready } from './global/instantiate';
import initAllPolyfills from './global/polyfills';

initAllPolyfills(); // leave polyfills at top pls 🍣

ready(() => {
  internetExplorerBodges();
})